import React, { useLayoutEffect, useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Header from './Layouts/Header';
import Footer from './Layouts/Footer';
import InquiryModal from './InquiryModal';
import { fetchJobs } from '../utils/apiService';

// Import Images
import imgjobDefault from '../assets/image/img-2.jpg';

const JobCard = ({ id, title, category, date, location, type, experience, salary, shortDesc, longDetails, img, onInquiry }) => {
  const [isActive, setIsActive] = useState(false);

  return (
    <div className="job-card">
      <div className="job-header">
        <div
          className="company-logo"
          dangerouslySetInnerHTML={{ __html: `<img src="${img}" alt="img" />` }}
        />

        <div className="job-main">
          <div
            className="job-title"
            dangerouslySetInnerHTML={{ __html: title }}
          />

          <div className="job-meta">
            <span className="color-primary"> {category} </span>
            <label className="mx-1"> | </label>
            <span className="job-date">Posted on: {date}</span>
          </div>

          <div className="badges mb-3 flex flex-wrap g-10">
            <span className="badge pill"><b>Location:</b> {location} </span>
            <span className="badge pill"><b>Job Type:</b> {type}</span>
            <span className="badge pill"><b>Experience:</b> {experience} </span>
            <span className="badge pill"><b>Salary:</b> {salary} </span>
          </div>
          <div className="job-short-desc">
            <p>{shortDesc}</p>
          </div>
        </div>

        <div className="job-actions">
          <button className="tf-btn mb-2 w-100" onClick={() => onInquiry(title, id)}>
            <span>Apply Now</span>
          </button>
          <button className="tf-btn w-100" onClick={() => setIsActive(!isActive)}>
            <span>{isActive ? 'Read Less' : 'Read More'}</span>
          </button>
        </div>
      </div>

      <div className={`job-details ${isActive ? 'active' : ''}`}>

        <div className="job-long-desc" dangerouslySetInnerHTML={{ __html: longDetails }} />

        <div className="job-footer-text mt-3">
          Create user-centered designs by understanding business requirements and user feedback.
        </div>
      </div>
    </div>
  );
};

const Jobs = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedService, setSelectedService] = useState('');
  const [selectedJobId, setSelectedJobId] = useState(null);
  const [jobs, setJobs] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useLayoutEffect(() => {
    const timer = setTimeout(() => {
      if (window.animationText) window.animationText();
      if (window.scrollingEffect) window.scrollingEffect();
      if (window.animateImgItem) window.animateImgItem();

      if (window.ScrollTrigger) {
        window.ScrollTrigger.refresh();
      }
    }, 800);

    return () => {
      clearTimeout(timer);
      if (window.revertAnimations) window.revertAnimations();
      if (window.revertHeadline) window.revertHeadline();
    };
  }, [jobs]);

  useEffect(() => {
    const getJobs = async () => {
      setIsLoading(true);
      const result = await fetchJobs();
      if (result && result.status && result.data) {
        setJobs(result.data);
      }
      setIsLoading(false);
    };
    getJobs();
  }, []);

  const openModal = (service, id) => {
    setSelectedService(service);
    setSelectedJobId(id);
    setIsModalOpen(true);
  };

  const getImageUrl = (imgVal) => {
    if (!imgVal) return imgjobDefault; // Fallback
    const imgStr = imgVal.toString().trim();
    return imgStr.startsWith('http')
      ? imgStr
      : `${process.env.REACT_APP_STORAGE_BASE_URL || 'http://localhost:8000/storage'}/${imgStr}`;
  };

  return (
    <div className="wrapper position-relative">
      <Header />
      <div className="page-title">
        <div className="tf-container">
          <div className="page-title-content text-center">
            <h1
              className="title ml-11"
              dangerouslySetInnerHTML={{ __html: '<span class="split-text effect-right">Jobs</span>' }}
            />
            <div className="breadkcum">
              <Link to="/" className="link-breadkcum body-2 fw-7">
                <span className="split-text effect-right" dangerouslySetInnerHTML={{ __html: 'Home' }} />
              </Link>
              <span className="dot"></span>
              <span className="page-breadkcum body-2 fw-7">
                <span className="split-text effect-right" style={{ color: 'var(--primary)' }} dangerouslySetInnerHTML={{ __html: 'Jobs' }} />
              </span>
            </div>
          </div>
        </div>
      </div>
      <div className="main-content">
        <div className="list-post-gird tf-spacing-2">
          <div className="tf-container">
            <div className="row rg-30">
              <div className="col-xl-12">
                <div className="row">
                  {isLoading ? (
                    <div className="col-12 text-center py-5">
                      <p>Loading jobs...</p>
                    </div>
                  ) : jobs.length === 0 ? (
                    <div className="col-12 text-center py-5">
                      <p>No jobs available.</p>
                    </div>
                  ) : (
                    jobs.map((job) => (
                      <JobCard
                        key={job.id}
                        id={job.id}
                        title={job.title}
                        category={job.category || 'General'}
                        date={job.posted_on}
                        location={job.location}
                        type={job.job_type}
                        experience={job.experience}
                        salary={job.salary}
                        shortDesc={job.description}
                        img={getImageUrl(job.image)}
                        onInquiry={openModal}
                        longDetails={job.long_description}
                      />
                    ))
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
      <InquiryModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        initialService={selectedService}
        jobId={selectedJobId}
        mode="apply"
      />
    </div>
  );
};

export default Jobs;
